export default __webpack_public_path__ + "static/media/profile.094946ae.svg";